import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppWindow } from '../components/ExtensionWindow/AppWindow';
import { ProcessInfo } from '../State/ProcessInfo';
import { WindowRoutingState } from '../components/ExtensionWindow/WindowRoutingState';
import { createGlobalContext } from '../components/ExtensionWindow/GlobalContext';
import { getWorkerUrlsInsideVite } from '../workers/getWorkerUrlsInsideVite';

ProcessInfo.setProcess({processType: "Extension UI"});

const domNode = document.createElement('div');
domNode.id = 'root';
const root = createRoot(domNode); 
(async () => {
	const globalContext = await createGlobalContext(getWorkerUrlsInsideVite());
	const windowRoutingState = new WindowRoutingState(globalContext);
	root.render(
		<AppWindow {...{globalContext, windowRoutingState}} />
	);
	document.body.appendChild(domNode);
})();

